<template>
  <div>
    <el-dialog v-dialogDrag :visible.sync="dlgVisible" :title="title" width="500px" :close-on-click-modal="false" :close-on-press-escape="false">
      <p style="font-size: 14px">请选择复制到的{{ targetRuleName }}:</p>
      <div style="margin:10px 0px">
        <el-select v-if="!showTargetTree" v-model="selectedTargetItems" placeholder="请选择" multiple size="small" style="width: 100%">
          <el-option v-for="item in targetItemList" :key="item.folderId" :disabled="!item.canEdit" :label="item.folderName" :value="item.folderId"> </el-option>
        </el-select>
        <el-cascader
          v-else
          :key="cascaderKey"
          v-model="selectedTargetItems"
          size="small"
          popper-class="multiplexCascader"
          :options="targetItemList"
          :props="props"
          style="width:100%"
          clearable
        ></el-cascader>
      </div>
      <p style="font-size: 14px">请勾选要复制的{{ subRuleName }}:</p>
      <el-table
        ref="multipleTable"
        :key="tabKey"
        :data="dataListToCopy"
        tooltip-effect="dark"
        style="width: 100%; min-height: 300px"
        height="calc(100% - 90px)"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="49" align="center" />
        <el-table-column prop="folderName" :label="labelTab" align="left" />
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dlgVisible = false">取 消</el-button>
        <el-button v-preventReClick size="small" type="primary" @click="handleSubmit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { TreeUtils } from "@/CommonDP/utils/tree";

export default {
  props: {
    treeData: {
      type: Object,
      required: false,
      default: () => {}
    },
    // 树节点的内容
    data: {
      type: Array,
      required: false,
      default: () => []
    },
    orderRule: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      dlgVisible: false,
      selectionData: [],
      targetRuleName: "",
      selectedTargetItems: [],
      targetItemList: [],
      dataListToCopy: [],
      showTargetTree: false,
      subRuleName: "",
      labelTab: "",
      multiplexIndex: 2, // 这个代表的是按钮的下标
      props: {
        children: "childrenList",
        label: "folderName",
        value: "folderId",
        checkStrictly: true,
        multiple: true,
        emitPath: false
      },
      title: "",
      cascaderKey: 1,
      tabKey: 1
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  methods: {
    show(parentNodeData, index) {
      this.selectionData = [];
      this.dataListToCopy = [];
      this.dlgVisible = true;
      this.tabKey++;
      this.init(parentNodeData, index);
    },

    init(parentNodeData, index) {
      const { currentRuleName } = parentNodeData;
      this.selectedTargetItems = [];
      this.targetRuleName = currentRuleName;
      this.subRuleName = parentNodeData.subordinateName || parentNodeData.name;
      this.labelTab = this.subRuleName + "名称";
      this.title = "复用" + (this.subRuleName || "");
      this.dataListToCopy = parentNodeData.childrenList;
      this.showTargetTree = parentNodeData.level > 0;
      this.multiplexIndex = index;
      this.$nextTick(() => {
        this.targetItemList = [];
        if (!this.showTargetTree) {
          this.targetItemList = this.data.filter(({ folderId }) => folderId !== parentNodeData.folderId);
        } else {
          this.cascaderKey++;
          let tree = JSON.parse(JSON.stringify(this.data));
          const treeUtils = new TreeUtils({ idFieldName: "folderId", childrenFieldName: "childrenList" });
          tree = treeUtils.cutTree(tree, parentNodeData.level, [parentNodeData.folderId]);
          const _list = [...tree];
          for (const item of _list) {
            item.disabled = !item.canEdit;
            if (item.childrenList) _list.push(...item.childrenList);
          }
          this.targetItemList = tree;
        }
      });
    },

    async handleSubmit() {
      if (!this.selectionData.length) {
        this.$warn("请勾选要复制的项");
        return;
      }
      if (!this.selectedTargetItems.length) {
        this.$warn("请选择要复制到的" + this.targetRuleName);
        return;
      }
      const data = {
        multiplexIndex: this.multiplexIndex,
        selectionData: this.selectionData,
        itemsToCopy: this.selectionData,
        multiplexData: this.selectedTargetItems,
        targetParent: this.selectedTargetItems
      };
      await this.$emit("callback", data);
      this.dlgVisible = false;
    },

    handleSelectionChange(val) {
      this.selectionData = val;
    }
  }
};
</script>

<style lang="scss">
.multiplexCascader {
  .el-cascader-panel li[aria-haspopup] .el-checkbox {
    display: none;
  }
}
</style>
